import React from "react";
import { useFormikContext, getIn } from "formik";
import { Typography, Box } from "@material-ui/core";
import { MyRadioGroup } from "components/MyRadioGroup";
import { fontConfig } from "theme/fontConfig";

const RadioGroupField = ({
  name,
  title,
  formsControls = [],
  row = true,
  mandatory = false,
  className = "",
  handleAction,
  manuel = false,
  ...rest
}) => {
  const { values, setFieldValue } = useFormikContext();
  const fieldValue = getIn(values, name);

  const handleChange = (val) => {
    handleAction(val);
    !manuel && setFieldValue(name, val.target.value);
  };

  return (
    <Box display="flex" flexDirection="column" mb={2} className={className}>
      {title && (
        <Typography
          style={{
            fontSize: 12,
            fontFamily: fontConfig.FormManageRadioTextFont.family,
            fontWeight: 500,
            color: "#3F4254",
            marginBottom: 4,
          }}
        >
          {title}
          {mandatory && <span style={{ color: "red", fontSize: 15 }}> *</span>}
        </Typography>
      )}
      <MyRadioGroup
        name={name}
        row={row}
        value={fieldValue}
        handleChange={handleChange}
        formsControls={formsControls}
        {...rest}
      />
    </Box>
  );
};

export default RadioGroupField;
